import React, { Suspense } from "react";

import HdLoader from "@hd/ui-kit/hd-loader/HdLoader";
import HdModal from "@hd/ui-kit/hd-modal/HdModal";

import { useAuth } from "./useAuth";

const ModalContent = React.lazy(
  () => import("./components/StepUpAuthModalContent")
);
function StepUpAuthModal() {
  const { requiresMfaStepUp, setRequiresMfaStepUp } = useAuth();

  return (
    <HdModal
      backdrop={true}
      isOpen={requiresMfaStepUp}
      closeOnEsc={false}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          setRequiresMfaStepUp(false, null, null);
        }
      }}
      // closeOnClickOutside={false}
      className="p-2 bg-white w-[324px] h-[320px] flex flex-col z-40"
    >
      <Suspense fallback={<HdLoader></HdLoader>}>
        <ModalContent></ModalContent>
      </Suspense>
    </HdModal>
  );
}

export default StepUpAuthModal;
